/* unplugin-vue-components disabled */import script from "./w-elmessage.vue?vue&type=script&lang=ts"
export * from "./w-elmessage.vue?vue&type=script&lang=ts"

import "./w-elmessage.vue?vue&type=style&index=0&id=be85113a&lang=scss"

const __exports__ = script;

export default __exports__